import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { getColumns } from "./TopClientsTable/TcTableConfig";
import useColumns from "@harbor/elements/utils/table/hooks/columns";
//style
import css from "./topClientsMagneticStyle.less";
import AppHOC from "../../../generics/AppHOC";
import ApiService from "../../../config/api-config";
import TopClientsReportBarChart from "./TopClientsReportBarChart";
import TopClientsTable from "./TopClientsTable";
import TableStore from "@harbor/elements/utils/table/store";
import SectionHeading from "../../../common/SectionHeading";
import { useI18n } from "../../../i18n/useI18n";

let defaultSort = [["display_usage_col", "desc"]];
const mapStateToProps = (state) => ({
  applications: state.vanalytics.applications,
});

const TopClientsReport = (props) => {
  const { tViews } = useI18n();
  const [topClientsData, setTopClientsData] = React.useState([]);
  const [tableStore, setTableStore] = useState(null);
  const [tableLoader, setTableLoader] = useState(true);
  const [tableError, setTableError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      let columns = getColumns(props);
      const columnsConfig = () => columns;
      const columnsHook = useColumns({
        config: columnsConfig,
        order: defaultSort,
      });
      let tableStore = new TableStore({
        query: { pageLength: 100 },
        hooks: [columnsHook],
        fetchData: async ({ query, setSource }) => {
          console.debug("query", query);
          let payload = props.globalV4PayloadReport
            ? { ...props.globalV4PayloadReport }
            : props.globalFilter.globalV4Payload;
          setTableError(null);
          setTableLoader(true);
          let results = await ApiService.getTopUsersReportData(payload);
          if (results?.data?.data) {
            let top100Clients = results?.data?.data;
            let top100TableData = top100Clients.flatMap((client) => {
              if (client.top_used_apps && Array.isArray(client.top_used_apps)) {
                return client.top_used_apps.map((app, index) => ({
                  source_ip: index == 0 ? client.source_ip : "",
                  site_name: index == 0 ? client.site_name : "",
                  display_usage: index == 0 ? client.display_usage : "",
                  display_tx_usage: index == 0 ? client.display_tx_usage : "",
                  display_rx_usage: index == 0 ? client.display_rx_usage : "",
                  display_site_usage_percent:
                    index == 0 ? client.display_site_usage_percent : "",
                  top_used_apps: app.app_name || app,
                  display_top_used_apps_usage:
                    client.display_top_used_apps_usage[index],
                  usage: index == 0 ? client.usage : "",
                  app_name: app.app_name || app,
                }));
              }
              return client;
            });
            const tableData = top100TableData;
            setSource(tableData);
            let top10Clients = results?.data?.data?.slice(0, 10);
            setTopClientsData(top10Clients);
            setTableLoader(false);
          } else {
            if (results?.errorObject) {
              setTableError({
                isError: true,
                message: `${results?.errorObject?.message}.
        Failed with error code ${results?.errorObject?.errorCode}.
        Try again. Reload the page.`,
                errorCode: results?.errorObject?.errorCode,
              });
              setTableLoader(false);
            }
          }
        },
      });
      setTableStore(tableStore);
    };

    fetchData();
  }, []);

  return (
    <div className={css["top-clients-usage"]} data-cy="applicationTableView">
      <SectionHeading title={tViews("topClientsUsage")} />
      <div className="widget-wrapper">
        <TopClientsReportBarChart
          {...props}
          data={topClientsData}
          error={tableError}
          tableLoader={tableLoader}
        ></TopClientsReportBarChart>
      </div>
      <SectionHeading title={tViews("clientsReportTableHeading")} />
      <div className="widget-wrapper">
        <TopClientsTable
          {...props}
          tableStore={tableStore}
          tableLoader={tableLoader}
          tableError={tableError}
          defaultSort={defaultSort}
        ></TopClientsTable>
      </div>
    </div>
  );
};

TopClientsReport.propTypes = {
  globalFilter: PropTypes.object.isRequired,
  globalV4PayloadReport: PropTypes.object.isRequired,
  isTopClientsTableCallback: PropTypes.func,
  isTop10BarChartCallback: PropTypes.func,
};

export default connect(mapStateToProps, null)(AppHOC(TopClientsReport));
